module.exports = __webpack_public_path__ + "img/617.toaster.7408457f.svg";